/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Dual_Pass_LabelInputs */



/**
* | output |
* | --- |
* | "Dual-pass (normal + inverted)" |
*
* @param {Ocr_Dual_Pass_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_dual_pass_label = /** @type {((inputs?: Ocr_Dual_Pass_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Dual_Pass_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Double passage (normal + inversé)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Doppelpass (normal + invertiert)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Doppio passaggio (normale + invertito)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двухпроходная обработка (обычная + инвертированная)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Doble paso (normal + invertido)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双通道（正向+反向）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デュアルパス（通常＋反転）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्यूल-पास (सामान्य + उलटा)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Passagem dupla (normal + invertida)")
	return /** @type {LocalizedString} */ ("Dual-pass (normal + inverted)")
});